import './UserControls.scss';
import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { adminActions } from '@sonar-software/sonar-admin';
import { Button } from 'antd';
import { CopyText } from '@ui/text';
import { createAsyncSelectors } from '@lib/selectors';
import { MailOutlined } from '@ant-design/icons';
import React, { useCallback, useEffect, useState } from 'react';
import { useAction, useSonarSelector } from '@hooks';
const getInvitationLinkSelectors = createAsyncSelectors((state) => state.admin.users.byId.links.invitation.get);
const postSendInvitationLinkSelectors = createAsyncSelectors((state) => state.admin.users.byId.links.invitation.send.post);
export const ResendUserInviteButton = (props) => {
    const { userId, userIsLocked, shardName } = props;
    const userInviteLink = useSonarSelector(getInvitationLinkSelectors.data);
    const getUserInviteLink = useAction(adminActions.requestGetAdminUsersByIdLinksInvitation);
    const handleCopyUserInviteClicked = useCallback(() => {
        getUserInviteLink({
            shardName,
            userId
        });
    }, [getUserInviteLink, userId, shardName]);
    const [sendClicked, setSendClicked] = useState(false);
    const sendUserInviteEmailIsRequested = useSonarSelector(postSendInvitationLinkSelectors.isRequested);
    const sendUserInviteEmail = useAction(adminActions.requestPostAdminUsersByIdLinksInvitationSend);
    const handleSendUserInviteClicked = useCallback(() => {
        sendUserInviteEmail({
            shardName,
            userId
        });
        setSendClicked(true);
    }, [sendUserInviteEmail, userId, shardName]);
    useEffect(() => {
        if (sendClicked && !sendUserInviteEmailIsRequested) {
            setSendClicked(false);
        }
    }, [sendUserInviteEmailIsRequested, setSendClicked, sendClicked]);
    return (React.createElement(Button.Group, null,
        React.createElement(Button, { className: 'send-user-invite-button', disabled: sendClicked || userIsLocked, icon: React.createElement(MailOutlined, null), onClick: handleSendUserInviteClicked }, ADMIN_DASHBOARD_COPY.RESEND_USER_INVITE),
        React.createElement(CopyText, { buttonOnly: true, onClick: handleCopyUserInviteClicked, text: userInviteLink === null || userInviteLink === void 0 ? void 0 : userInviteLink.link, tooltip: ADMIN_DASHBOARD_COPY.COPY_USER_INVITE_LINK })));
};
